// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zzb[data-v-531e4e76] {\n  display: flex;\n  flex-direction: column;\n}\n.line[data-v-531e4e76] {\n  height: 20px;\n  width: 100%;\n  background: #ccc;\n}\n.Dtop_l_num[data-v-531e4e76] {\n  text-align: center;\n}\n.topNum_title[data-v-531e4e76] {\n  font-size: 12px;\n  color: #787a7d;\n  margin: 0 0 10px 0;\n}", ""]);
// Exports
module.exports = exports;
